import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Space, Upload } from "antd";
import {
  BoldOutlined,
  ItalicOutlined,
  LinkOutlined,
  PaperClipOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

export default function ContractNoteModal({
  open,
  loading,
  onCancel,
  onSubmit,
  title = "Add Note",
  hint = null,
}) {
  const editorRef = useRef(null);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (!open) {
      setFiles([]);
      if (editorRef.current) editorRef.current.innerHTML = "";
    }
  }, [open]);

  const command = (name, value) => {
    editorRef.current?.focus();
    document.execCommand(name, false, value);
  };

  const submit = () => {
    const content = editorRef.current?.innerHTML || "";
    onSubmit(content, files.map((item) => item.originFileObj || item));
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={submit}
      confirmLoading={loading}
      okText={title}
      width={680}
      destroyOnClose
    >
      {hint ? (
        <div style={{ marginBottom: 12, color: "#6b7280", fontSize: 12, lineHeight: 1.5 }}>
          {hint}
        </div>
      ) : null}
      <Space style={{ marginBottom: 8 }}>
        <Button icon={<BoldOutlined />} onClick={() => command("bold")} aria-label="Bold" />
        <Button icon={<ItalicOutlined />} onClick={() => command("italic")} aria-label="Italic" />
        <Button icon={<UnorderedListOutlined />} onClick={() => command("insertUnorderedList")} aria-label="Bulleted list" />
        <Button
          icon={<LinkOutlined />}
          onClick={() => {
            const url = window.prompt("Link URL");
            if (url) command("createLink", url);
          }}
          aria-label="Insert link"
        />
        <Upload
          multiple
          fileList={files}
          beforeUpload={() => false}
          onChange={({ fileList }) => setFiles(fileList)}
        >
          <Button icon={<PaperClipOutlined />}>Attach</Button>
        </Upload>
      </Space>
      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        style={{ minHeight: 160, border: "1px solid #d9d9d9", borderRadius: 4, padding: 12 }}
      />
    </Modal>
  );
}
